import styled from 'styled-components';
import { alto, apple, curiousBlue, dustGray, emperor, hotCinnamon, thunderBird } from '../Colors/Colors';
const DEFAULTS = {
  small: {
    borderWidth: '1px',
    fontSize: '16px',
    verticalMargin: 'calc((40px - 1.25em) / 2)'
  },
  medium: {
    borderWidth: '1px',
    fontSize: '20px',
    verticalMargin: 'calc((50px - 1.25em) / 2)'
  },
  large: {
    borderWidth: '2px',
    fontSize: '25px',
    verticalMargin: 'margin-top: calc((60px - 1.25em) / 2)'
  },
  default: {
    color: dustGray,
    borderColor: alto
  },
  primary: {
    color: apple,
    borderColor: null
  },
  error: {
    color: thunderBird,
    borderColor: null
  },
  warning: {
    color: hotCinnamon,
    borderColor: null
  },
  configure: {
    color: curiousBlue,
    borderColor: null
  },
  dark: {
    color: emperor,
    borderColor: null
  }
};
const Divider = /*#__PURE__*/styled.div.attrs(attrs => ({
  scale: 'medium',
  context: 'default',
  borderStyle: 'solid',
  orientation: 'horizontal',
  'aria-orientation': attrs.orientation,
  role: 'separator',
  ...attrs
})).withConfig({
  displayName: "Divider",
  componentId: "sc-19sduhe-0"
})(["width:", ";line-height:1.25em;font-size:", ";display:flex;flex-direction:", ";align-items:center;gap:", ";", ";min-height:1.25em;color:", ";:before,:after{border-", "-width:", ";border-", "-style:", ";border-", "-color:", ";flex:1;content:'';}"], _ref => {
  let {
    orientation
  } = _ref;
  return orientation === 'horizontal' ? '100%' : 'unset';
}, _ref2 => {
  let {
    scale
  } = _ref2;
  return DEFAULTS[scale || 'medium'].fontSize;
}, p => p.orientation === 'horizontal' ? 'row' : 'column', _ref3 => {
  let {
    orientation
  } = _ref3;
  return orientation === 'horizontal' ? '.5em' : '.25em';
}, p => p.orientation === 'horizontal' ? '' : 'align-self: stretch', props => {
  var _props$theme, _props$theme$fontColo, _props$theme$fontColo2;

  return props.color || ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$fontColo = _props$theme.fontColors) === null || _props$theme$fontColo === void 0 ? void 0 : (_props$theme$fontColo2 = _props$theme$fontColo.body) === null || _props$theme$fontColo2 === void 0 ? void 0 : _props$theme$fontColo2.base) || DEFAULTS[props.context || 'default'].color;
}, p => p.orientation === 'horizontal' ? 'top' : 'left', props => props.borderWidth || DEFAULTS[props.scale || 'medium'].borderWidth, p => p.orientation === 'horizontal' ? 'top' : 'left', props => props.borderStyle, p => p.orientation === 'horizontal' ? 'top' : 'left', props => {
  var _props$theme2;

  return props.borderColor || ((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.borderColor) || DEFAULTS[props.context || 'default'].borderColor;
});
/** @component */

export default Divider;